import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite } from 'gsap';

export default {

    initialise(Hero) {
        this.node = findDOMNode(Hero);
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/modules/Features/animations.js